module.exports = __webpack_public_path__ + "img/102_L.c2c1fc10.png";